import React, { useState, useEffect } from 'react';
import { DiscreteColorLegend, RadialChart } from 'react-vis';
import { useResizeDetector } from 'react-resize-detector';
import PropTypes from 'prop-types';

import {
  color,
  renderHint,
  defaultLabel,
  sortFunctionByValue,
  renderDiscrete,
} from '../../../utils';

// Composant graphique pour afficher un Pie chart.
const Pie = props => {
  const [hint, setHint] = useState(false);
  const [data, setData] = useState([]);
  const { width, ref } = useResizeDetector();

  useEffect(() => {
    if (!props.data) return;

    let processedData = props.data || [];
    processedData = processedData.sort((a, b) => sortFunctionByValue(a, b));

    processedData = processedData.map((d, i) => ({
      ...d,
      label: d.label ? String(d.label) : defaultLabel,
      color: color(i, d.label, props.colorPalette),
    }));

    setData(processedData);
  }, [props.data, props.refreshes, props.colorPalette]);

  const processedData = [...data];

  // Logique pour les effets du hover.
  (processedData || []).forEach(d => {
    if (hint) {
      d.className = d.label === hint.label ? 'hovered' : 'not-hovered';
    } else {
      d.className = '';
    }
  });

  return (
    <div
      style={{ width: '50%', height: '100%' }}
      className="pie-chart-wrap"
      ref={ref}
    >
      <RadialChart
        colorType="literal"
        animation="noWobble"
        width={width || props.height}
        height={props.height}
        getAngle={d => d.value}
        data={processedData || []}
        onValueMouseOver={v => setHint(v)}
        onSeriesMouseOut={() => setHint(false)}
      >
        {hint && renderHint(hint, props.hint && props.hint(hint))}

        <DiscreteColorLegend
          items={(processedData || []).map((d, i) => ({
            title: renderDiscrete(d),
            color: color(i, d.label, props.colorPalette),
            disabled: d.className === 'not-hovered',
            hint: { ...d, x: 1, y: -1 },
          }))}
          onItemMouseEnter={item => setHint(item.hint)}
          onItemMouseLeave={() => setHint(false)}
        />
      </RadialChart>
    </div>
  );
};

Pie.propTypes = {
  colorPalette: PropTypes.string,
  crosshair: PropTypes.array,
  data: PropTypes.array,
  height: PropTypes.number,
  hint: PropTypes.bool,
  refreshes: PropTypes.number,
};

export default Pie;
